import { Button, TooltipTrigger } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { TooltipContainer } from '~/components/tooltip-container/TooltipContainer';
import { useUserUpload } from '~/views/alfred/research/useUserUpload/useUserUpload';

import { ChatInputConfig } from '../../chat-input';

export interface ChatSubmitButtonProps {
  isMessagePending: boolean;
  inputValue: string;
  abortRequest?: () => void;
  config?: ChatInputConfig;
}

export const ChatSubmitButton = ({
  isMessagePending,
  inputValue,
  abortRequest,
  config,
}: ChatSubmitButtonProps) => {
  const { t } = useTranslation('chat');
  const isAlfredEverywhere = config?.alfredEverywhere;

  const uploadingFiles = useUserUpload(state =>
    state.files.filter(file => file.status === 'uploading')
  );

  const hasEmptyInput = !inputValue.trim();
  const hasUploadingFiles = uploadingFiles.length > 0;
  const isSubmitButtonDisabled =
    hasEmptyInput ||
    hasUploadingFiles ||
    (isAlfredEverywhere && isMessagePending);

  return (
    <TooltipContainer
      label={t('chat:stopResponse')}
      inPortal
      trigger={[TooltipTrigger.Hover]}
      disabled={!isMessagePending}
    >
      {isMessagePending && !isAlfredEverywhere ? (
        <Button
          data-testid="abort-button"
          iconName="Stop"
          onClick={abortRequest}
        />
      ) : (
        <Button
          data-testid="submit-button"
          variant="primary"
          iconName="ArrowUp"
          disabled={isSubmitButtonDisabled}
        />
      )}
    </TooltipContainer>
  );
};
